import axiosBase from "axios";

import Axios from "../../../_helpers/axiosHelper";
import { API_URL } from "../constants";
import {
  ICompanyState,
  ICreateCompany,
  IResponseAuth,
  IUserCredential,
} from "../reducers";

export const loginUserService = (
  email: string,
  password: string,
): Promise<IResponseAuth> => {
  const body: any = { email, password };
  return Axios.post("/login", body);
};

export const GetUserService = () => {
  return Axios.get(`/user/get`);
};

export const tokenIsValidService = () => {
  return Axios.get(`/tokenIsValid`);
};

export const logoutUserService = () => {
  return Axios.post(`/logout`);
};

export const register = (request: IUserCredential) => {
  const body: any = request;
  return Axios.post(`/register`, body);
};

export const verifyPhoneNumberService = (code: number) => {
  const body: any = { code };
  return Axios.post(`/verifyPhoneNumber`, body);
};

//TODO Refacto
export const getCompanyInfos = (company: string) => {
  let ENDPOINT: RequestInfo;

  isNaN(parseInt(company))
    ? (ENDPOINT =
        `https://api.insee.fr/entreprises/sirene/V3/siret?q=denominationUniteLegale%3A%22` +
        company +
        `%22&masquerValeursNulles=false`)
    : (ENDPOINT =
        `https://api.insee.fr/entreprises/sirene/V3/siret?q=siren%3A%22` +
        company +
        `%22&masquerValeursNulles=false`);

  const parameters: RequestInit = {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: "Bearer f592c30b-3a31-36ed-806a-67a2fd211048",
    },
    mode: "cors",
  };

  return fetch(ENDPOINT, parameters)
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (json.header.statut === 200) {
        const data: ICompanyState[] = [];
        json.etablissements.forEach((etabli: any) => {
          data.push({
            siren: etabli.siren,
            siret: etabli.siret,
            name: etabli.uniteLegale.denominationUniteLegale,
            address: `${etabli.adresseEtablissement.numeroVoieEtablissement} ${etabli.adresseEtablissement.typeVoieEtablissement} ${etabli.adresseEtablissement.libelleVoieEtablissement}`,
            city: etabli.adresseEtablissement.libelleCommuneEtablissement,
            zip: etabli.adresseEtablissement.codePostalEtablissement,
          });
        });
        return { message: "OK", data };
      } else return { message: "Society doesn't exist" };
    })
    .catch((e) => {
      console.log(e);
    });
};

export const emailExists = (email: string) => {
  const body: any = { email };
  return Axios.post(`/user/exists`, body);
};

export const companyExists = (siren: string) => {
  const body: any = { siren };
  return Axios.post(`/society/exists`, body);
};

export const createCompany = (infos: ICreateCompany) => {
  return Axios.post(`/society/create`, infos);
};

export const forgotPassword = (email: string) => {
  return Axios.post(`/forgot-password`, { email: email });
};

export const resetPassword = async (password: string, token: string) => {
  return axiosBase
    .create({
      baseURL: API_URL,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .post(`/reset-password`, { password: password });
};
